import { Outlet } from "react-router-dom";
import Header from "../../../components/header/Header.jsx";
import ApplicantSideBar from "../../sidebar/applicantSidebar/ApplicantSideBar.jsx";

export function ApplicantLayout(){
    
    return (
        <div>
            <Header title='Wisdom Dashboard'/>
            <div className="layout-container">
                <ApplicantSideBar />
                <div className="layout-outlet">
                    <Outlet />
                </div>
            </div>
        </div>
    )
}